const auth = [
  'Moderator',
  'Administrator',
  'Organization Administrator'
]
const admin = ['Administrator']

/**
 * Export config
 */
const config = {
  /**
   * All roles
   */
  roles: [
    'Member',
    ...auth
  ],

  /**
   * Reset time
   */
  resetTimeout: 600000,

  /**
   * Authorized users
   */
  authorized: auth,

  /**
   * Local storage
   */
  storage: {
    name: 'persist:root'
  },

  /**
   * Main navigation
   */
  navigation: [
    // {
    //   name: 'Dashboard',
    //   icon: 'icon-chart',
    //   auth: ['Administrator', 'Organization Administrator']
    // },
    {
      auth,
      name: 'Accounts',
      icon: 'icon-user',
    },
    {
      auth,
      name: 'Posts',
      icon: 'icon-document',
      group:[
        {name: 'Published', auth: admin},
        {name: 'Blocked', auth},
        {name: 'Reported', auth},
      ],
    },
    {
      name: 'Organizations',
      icon: 'icon-building',
      auth: admin,
      group:[
        {name: 'Businesses', auth: admin},
        {name: 'Spaces', auth},
        {name: 'Groups', auth},
      ],
    },
    {
      name: 'Audit Log',
      icon: 'icon-document',
      auth: admin
    },
    {
      name: 'Reports',
      icon: 'icon-document',
      auth: admin
    },
    {
      name: 'Support',
      icon: 'icon-headphone',
      group: [
        {name: 'Tickets', auth: admin},
      ],
      auth: admin
    },
    {
      name: 'Settings',
      icon: 'icon-cog',
      group: [
        {name: 'General', auth: admin},
        {name: 'Content', auth: admin},
        {name: 'Roles', auth: admin},
      ],
      auth: admin
    },
  ],
  industries: [
    'Retail',
    'Hotel and Lodging',
    'Artificial Intelligence',
    'Education',
    'Entertainment and Leisure',
    'Healthcare',
    'Telecommunications',
    'Utilities',
    'Finance and Insurance',
    'Information Technology',
    'Transportation and Logistics',
    'Agriculture, Forestry and Fishing',
    'Construction',
    'Media and Entertainment',
    'Legal',
    'Government and Public Administration',
    'Real Estate and Property Management',
    'Manufacturing',
    'Wholesale and Distribution',
    'E-commerce and Online Retail'
  ]
}
export default config